import Oidc from 'oidc-client'

export const oidcSettings = {
  // accessTokenExpiringNotificationTime: 30,
  authority: process.env.VUE_APP_AUTHSERVER,
  clientId: 'code', // client_id if you use typescript, see note below
  redirectUri: `${window.document.location.protocol}//${window.document.location.host}/oidc-callback`, // client_id if you use typescript, see note below
  responseType: 'code',//'token id_token',
  scope: 'openid profile api1 boyuan.api user.metainfo offline_access',
  postLogoutRedirectUri: `${window.document.location.protocol}//${window.document.location.host}/logout`,
  popupWindowFeatures: `location=no,toolbar=no,width=650,height=750,top=100,left=${(window.screen.width/2)-(650/2)}`,
  silentRedirectUri: `${window.document.location.protocol}//${window.document.location.host}/oidc-silent-renew.html`,
  automaticSilentRenew: true,
  automaticSilentSignin: false,
  userStore: new Oidc.WebStorageStateStore({ store: window.sessionStorage })
  // prompt: "login"
}
